import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CategoriaImgFilterService {

  // Links compartidos de ODS
  readonly odsLinks: Record<string, string> = {
    '1': 'https://www.un.org/sustainabledevelopment/es/poverty/',
    '2': 'https://www.un.org/sustainabledevelopment/es/hunger/',
    '3': 'https://www.un.org/sustainabledevelopment/es/health/',
    '4': 'https://www.un.org/sustainabledevelopment/es/education/',
    '5': 'https://www.un.org/sustainabledevelopment/es/gender-equality/',
    '6': 'https://www.un.org/sustainabledevelopment/es/water-and-sanitation/',
    '7': 'https://www.un.org/sustainabledevelopment/es/energy/',
    '8': 'https://www.un.org/sustainabledevelopment/es/economic-growth/',
    '9': 'https://www.un.org/sustainabledevelopment/es/infrastructure/',
    '10': 'https://www.un.org/sustainabledevelopment/es/inequality/',
    '11': 'https://www.un.org/sustainabledevelopment/es/cities/',
    '12': 'https://www.un.org/sustainabledevelopment/es/sustainable-consumption-production/',
    '13': 'https://www.un.org/sustainabledevelopment/es/climate-change-2/',
    '14': 'https://www.un.org/sustainabledevelopment/es/oceans/',
    '15': 'https://www.un.org/sustainabledevelopment/es/biodiversity/',
    '16': 'https://www.un.org/sustainabledevelopment/es/biodiversity/',
    '17': 'https://www.un.org/sustainabledevelopment/es/globalpartnerships/',
  };

  constructor() { }

  /**
   * Obtiene el link de un ODS por su número
   */
  getOdsLink(odsNumber: string): string {
    return this.odsLinks[odsNumber] || '';
  }

  /**
   * Obtiene todos los links de ODS
   */
  getAllOdsLinks(): Record<string, string> {
    return this.odsLinks;
  }
}
